module.exports = __webpack_public_path__ + "img/flu-virus-2.63f14d94.png";